module.exports = __webpack_public_path__ + "img/wear-tight.fb7360fd.jpg";